<template>
  <div>

    <div class="m-4" v-if="userInfo.type == 'legal'">
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field direction="rtl" label="نام شرکت/فروشگاه" type="text"
                        class="mt-4"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.name"
                        :rules="rules.companyName" v-model="value.companyName" dense
                        outlined
                        v-on:input="updateValue( )"/>
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="شماره ثبت" type="text" class="mt-4"
                        :rules="rules.registration_number"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.registration_number"
                        outlined
                        v-model="value.registrationNumber" dense/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field direction="rtl" label="کد اقتصادی" type="text" class="mt-4"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.economic_code"
                        :rules="rules.economic_code" v-model="value.economicCode" dense outlined
                        v-on:input="updateValue( )"
          />
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="شناسنامه ملی سازمانی" type="text" class="mt-4"
                        :rules="rules.organization_identity"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.organization_identity"
                        v-model="value.organizationIdentity" dense outlined
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">

          <v-select
              :items="items"
              item-text="name"
              item-value="valueName"
              label=" نوع شرکت"
              v-model="value.companyType"
              dense
              outlined
              return-object
              v-on:input="updateValue( )"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="حوزه فعالیت" type="text"
                        v-model="value.activity" dense
                        outlined
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-file-input counter
                        dense
                        prepend-icon="mdi-camera"
                        :rules="rules.registration_ad"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.registration_ad"
                        v-model="value.registrationAd"
                        outlined
                        label="تصویر آگهی ثبت شرکت"
                        v-on:input="updateValue( )">
          </v-file-input>

        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-file-input counter
                        dense
                        prepend-icon="mdi-camera"
                        v-model="value.lastPublishedAd"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.last_published_ad"
                        :rules="rules.last_published_ad"
                        outlined
                        label="تصویر آخرین آگهی رسمی منتشر شده"
                        v-on:input="updateValue( )"
          >
          </v-file-input>

        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-file-input counter
                        prepend-icon="mdi-camera"
                        dense
                        outlined
                        v-model="value.statute"
                        label="تصویر اساسنامه شرکت"
                        v-on:input="updateValue( )">
          </v-file-input>

        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-file-input counter
                        prepend-icon="mdi-camera"
                        dense
                        outlined
                        v-model="value.argentLetterPic"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.agent_letterpic"
                        label="تصویر نامه معرفی نماینده شرکت"
                        v-on:input="updateValue( )">
          </v-file-input>
          <input type="hidden" value="true" v-model="value.legalPersonStatus"
                 v-on:input="updateValue( )">


        </v-flex>
      </v-row>
    </div>

    <div class="m-4" v-else-if="userInfo.type == 'regular'">
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="شماره همراه  " type="text"
                        color="gray"
                        outlined dense readonly :value="user.phone"
          />
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="شماره ثابت" type="text"
                        :rules="rules.telephone" v-model="value.telephone"
                        outlined dense
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="نام پدر" type="text"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.father_name"
                        :rules="rules.fatherName" v-model="value.fatherName"
                        outlined dense
                        v-on:input="updateValue( )"/>
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="کد ملی" type="text"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.mcode"
                        :rules="rules.nationalCode" v-model="value.nationalCode"
                        outlined dense
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="شماره شناسنامه" type="text"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.nid"
                        :rules="rules.id" v-model="value.id"
                        outlined dense
                        v-on:input="updateValue( )"/>
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <date-picker label="تاریخ تولد"
                       view="year"
                       format="YYYY-MM-DD"
                       display-format="jYYYY-jMM-jDD"
                       max="2006-01-01"
                       start="2006-01-01"
                       :error-messages="errorsMessage === null ? [] : errorsMessage.birthday"

                       :rules="rules.birthday" v-model="value.birthday"
                       v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="محل تولد" type="text"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.born_city"
                        outlined dense
                        :rules="rules.placeBirthday" v-model="value.placeBirthday"
                        v-on:input="updateValue( )"/>
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="کد پستی" type="text"
                        outlined dense
                        :rules="rules.postalCode" v-model="value.postalCode"
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="ایمیل" type="email"
                        outlined dense readonly
                        :value="user.email"
          />
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="نحوه آشنایی" type="text" v-model="value.introduction"
                        outlined dense
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-file-input label="عکس کارت ملی" show-size :rules="rules.nationalCodePic"
                        v-model="value.nationalCodePic"
                        outlined dense
                        prepend-icon=""
                        append-icon="mdi-camera"
                        :error-messages="errorsMessage === null ? [] : errorsMessage.nidimage"
                        v-on:input="updateValue( )"

          />
        </v-flex>
        <v-flex xs12 sm12 md6 xl6 lg6 class="p-2">
          <v-text-field label="پلاک" :rules="rules.plaque" type="text"
                        v-model="value.plaque"
                        outlined dense
                        v-on:input="updateValue( )"/>
        </v-flex>
      </v-row>
      <v-row class="p-4">
        <v-textarea label="آدرس کامل" rows="3"
                    :error-messages="errorsMessage === null ? [] : errorsMessage.address"
                    color="teal" :rules="rules.address" v-model="value.address"
                    outlined dense
                    v-on:input="updateValue( )"/>
      </v-row>
    </div>

  </div>

</template>
<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  props: {
    value: {
      type: Object,
      default: {}
    },
    errorsMessage: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      userInfo: null,
      rules: {
        name: [val => (val || '').length > 0 || 'فیلد نام و نام خانوادگی اجباری می باشد.'],
        companyName: [val => (val || '').length > 0 || 'فیلد نام شرکت یا فروشگاه اجباری می باشد.'],
        registration_number: [val => (val || '').length > 0 || 'فیلد شماره ثبت اجباری می باشد.'],
        economic_code: [val => (val || '').length > 0 || 'فیلد کد اقتصادی اجباری می باشد.'],
        organization_identity: [val => (val || '').length > 0 || 'فیلد شناسنامه ملی سازمانی اجباری می باشد.'],
        registration_ad: [val => (val || '').size > 0 || 'فیلد تصویر اگهی ثبت شده اجباری می باشد.'],
        last_published_ad: [val => (val || '').size > 0 || 'فیلد تصویر آخرین اگهی رسمی منتشر شده اجباری می باشد.'],
        phone: [val => (val || '').length > 0 || 'فیلد شماره موبایل اجباری می باشد.'],
        telephone: [val => (val || '').length > 0 || 'فیلد شماره ثابت اجباری می باشد. '],
        username: [val => (val || '').length > 0 || 'فیلد نام کاربری اجباری می باشد. '],
        fatherName: [val => (val || '').length > 0 || 'فیلد نام پدر اجباری می باشد. '],
        nationalCode: [val => (val || '').length > 0 || 'فیلد کدملی اجباری می باشد. '],
        birthday: [val => (val || '').length > 0 || 'فیلد  کدملی اجباری می باشد. '],
        id: [val => (val || '').length > 0 || 'فیلد  شماره شناسنامه اجباری می باشد. '],
        placeBirthday: [val => (val || '').length > 0 || 'فیلد  محل تولد اجباری می باشد. '],
        postalCode: [val => (val || '').length > 0 || 'فیلد  کد پستی اجباری می باشد. '],
        nationalCodePic: [val => (val || '').size > 0 || 'فیلد  عکس کارت ملی اجباری می باشد. '],
        address: [val => (val || '').length > 0 || 'فیلد  آدرس اجباری می باشد. '],
        plaque: [val => (val || '').length > 0 || 'فیلد  پلاک اجباری می باشد. '],
      },
      items: [
        {name: 'دولتی', valueName: 'governmental'},
        {name: 'خصوصی', valueName: 'private'},
        {name: 'سهامی عام', valueName: 'common_stock'},
        {name: 'سهامی خاص', valueName: 'special_stock'}
      ],
      legalPerson: 'legal_person',
      realPerson: 'real_person',
      person: 1,
      data: null,
      rejectMessage: null,
    }
  },

  mounted() {
    this.userInfo = this.getUser();
    this.getInfo();
    this.$store.dispatch(SET_BREADCRUMB, [{title: 'ویرایش پروفایل'}])
    // this.rejectMessage = JSON.parse(this.userInfo.extras)
  },
  computed: {
    showMessage() {
      return this.rejectMessage.split('\n');
    }


  },

  methods: {
    getInfo() {
      this.requestApiGet(`authRequest/${this.userInfo.id}`)
          .then(({data}) => {
            this.rejectMessage = data.extras.adminMessage
            if (data.type == 'legal') {
              this.setUserLegal(data);
            } else
              this.setUserRegular(data);
          })
    },

    setUserLegal(data) {
      this.value.legalPersonStatus = true;
      this.value.companyName = data.bussiness.name;
      this.value.companyType = data.bussiness.company_type;
      this.value.registrationNumber = data.bussiness.registration_number;
      this.value.economicCode = data.bussiness.economic_code;
      this.value.organizationIdentity = data.bussiness.organization_identity;
      this.value.activity = data.bussiness.activity;
      this.value.registrationAd = data.bussiness.registration_ad;
      this.value.lastPublishedAd = data.bussiness.last_published_ad;
      this.value.statute = data.bussiness.statute;


    },

    setUserRegular(data) {
      this.value.realPersonStatus = true;
      this.value.name = data.name;
      this.value.phone = data.phone;
      this.value.fatherName = data.user_info.father_name;
      this.value.nationalCode = data.user_info.mcode;
      this.value.id = data.user_info.nid
      this.value.birthday = data.user_info.birthday;
      this.value.placeBirthday = data.user_info.born_city;
      this.value.address = data.user_info.address;
      this.value.postalCode = data.user_info.postalCode;
      this.value.nationalCodePic = data.user_info.national_code_pic;
      this.value.telephone = data.user_info.telephone;
      this.value.username = data.username;
      this.value.plaque = data.user_info.plaque;
    },


    updateValue() {
      this.$emit('input', this.value)
    }
  }

}
</script>
